<ion-header>
  <ion-toolbar color="primary">
    <ion-title>{{title}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content fullscreen>
  <form [formGroup]="registerForm" (ngSubmit)="submitForm()">
    <ion-grid>
      <ion-row>
        <ion-col size="12">
          <ion-item lines="none" class="intl-phone-wrapper">
            <ion-label position="stacked" class="auth-button-label">Mobile number</ion-label>
            <input 
              class="auth-input"
              type="tel" 
              formControlName="phone" 
              ng2TelInput 
              [ng2TelInputOptions]="ng2TelCustomOptions"
              (hasError)="phoneHasError($event)" 
              #phoneNumber 
            />
            <p class="form-error" *ngIf="!registerForm.valid">{{errorMessage}}</p>
          </ion-item>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-item lines="none">
            <ion-label class="auth-button-label" position="stacked">
              Provider site
            </ion-label>
            <ion-input type="text" formControlName="site" color="input-text"></ion-input>
            <ion-button slot="end" style="margin-top: 3em;" fill="clear" (click)="showModal()">
              <ion-icon slot="icon-only" name="help-circle"></ion-icon>
            </ion-button>
            <control-label [control]="registerForm.controls['site']" fieldName="Site code"></control-label>
          </ion-item>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="6">
          <ion-item lines="none">
            <ion-label class="auth-button-label" position="stacked">First name</ion-label>
            <ion-input type="text" formControlName="first" color="input-text" #firstName></ion-input>
            <control-label [control]="registerForm.controls['first']" fieldName="First name"></control-label>
          </ion-item>
        </ion-col>
        <ion-col size="6">
          <ion-item lines="none">
            <ion-label class="auth-button-label" position="stacked">Last name</ion-label>
            <ion-input type="text" formControlName="last" color="input-text"></ion-input>
            <control-label [control]="registerForm.controls['last']" fieldName="Last name"></control-label>
          </ion-item>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="6">
          <ion-item lines="none" [ngClass]="registerForm.controls['gender'] | itemClassFix">
            <ion-label class="auth-button-label" position="stacked">Gender</ion-label>
            <ion-select formControlName="gender" interface="popover" placeholder="Select gender">
              <ion-select-option *ngFor="let gender of genders" value="{{gender.value}}">{{gender.valueText}}</ion-select-option>
            </ion-select>
            <control-label [control]="registerForm.controls['gender']" fieldName="Gender"></control-label>
          </ion-item>
        </ion-col>
        <ion-col size="6">
          <ion-item lines="none" [ngClass]="registerForm.controls['dob'] | itemClassFix">
            <ion-label class="auth-button-label" position="stacked">Date of birth</ion-label>
            <ion-datetime-button datetime="datetime"></ion-datetime-button>
            <ion-modal data-analytics-id="datetimeControl" [keepContentsMounted]="true">
              <ng-template>
                <ion-datetime id="datetime" presentation="date" displayFormat="MM-DD-YYYY" formControlName="dob" [max]="maxDateStr"></ion-datetime>
              </ng-template>
            </ion-modal>
            <control-label [control]="registerForm.controls['dob']" fieldName="Date of birth"></control-label>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-content>

<ion-footer class="auth-footer">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-button expand="block" (click)="cancel()" class="auth-button secondary">Cancel</ion-button>
        </ion-col>
        <ion-col>
          <ion-button expand="block" (click)="submitForm()" [disabled]="!registerForm.valid" class="auth-button primary">Register
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
</ion-footer>